<template>
  <div class="base-input">
    <label :for="id">{{ label }}</label>
    <input
      :value="value"
      @input="inputEvent"
      @blur="$emit('blur')"
      :placeholder="placeholder"
      :id="id"
      :disabled="disabled === true"
      :type="type"
      :required="required"
    />
  </div>
</template>

<script>
const shortid = require("shortid");

export default {
  data() {
    return {
      id: shortid.generate()
    };
  },
  props: {
    value: [String, Number],
    label: String,
    placeholder: String,
    disabled: Boolean,
    type: {
      type: String,
      default: "text",
      required: false
    },
    required: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  methods: {
    inputEvent(e) {
      this.$emit("input", e.target.value);
    }
  }
};
</script>

<style scoped lang="less">
</style>
